import React from 'react'
import Flex from 'typescript-styled-flex'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Logo from '../../assets/logo-booking.png'
import theme from '../../theme/theme'
import { Desktop, is } from '../MediaQuery'
import { getUserCurrency } from '../../reducers/userObject/selectors/object'
import { UserSelect } from '../../containers/BookingCalendar/ReservationModal/Components/ReservationModalHeader'
import useSize from '../../hooks/useSize'
import Price from '../Price/Price'
import { IntegrationWrapper } from './Wrapper'
import { Circle } from './Circle'
import { StyledLogoImg } from './Logo'
import { Label } from './Label'
import { NumberLabel } from './NumberLabel'

const BookingBar = ({
  reservationId,
  price,
  currency,
  t,
}: WithTranslation & IBookingBar) => {
  const isDesktop = is.desktop()
  const size = useSize()

  return (
    <Flex
      full={true}
      alignCenter={true}
      row={true}
      style={{
        background: '#ebedef',
        height: 'auto',
        minHeight: `${48 * size}px`,
        width: '100%',
      }}
    >
      <IntegrationWrapper
        size={size}
        style={{
          justifyContent: isDesktop ? 'flex-start' : 'space-between',
          maxHeight: isDesktop ? `${48 * size}px` : `${150 * size}px`,
        }}
      >
        <Flex alignCenter={true}>
          <Circle size={size} color={theme.colors.palette.booking} />
          <Desktop>
            {' '}
            <StyledLogoImg size={size} src={Logo} alt="logo booking.com" />
          </Desktop>
        </Flex>

        <Flex wrap={true} alignBaseline={true} full={true}>
          <Flex alignBaseline={true} wrap={false} justifyCenter={!isDesktop}>
            <Label size={size}>{t('reservation_reservation_id')}</Label>
            <NumberLabel size={size} style={{ marginRight: `${10 * size}px` }}>
              <UserSelect className={'text-select'}>{reservationId}</UserSelect>
            </NumberLabel>
          </Flex>
          <Label
            size={size}
            style={{ margin: '0px', marginTop: `${5 * size}px` }}
          >
            {`${t('BED_4331_booking_com_total_price')} `}
            <Price value={price} currency={currency} />
          </Label>
        </Flex>
      </IntegrationWrapper>
    </Flex>
  )
}

export interface IBookingBar {
  reservationId?: any
  price?: string
  currency?: string
}

const MapCurrencyToProps = state => ({
  currency: getUserCurrency(state),
})

export default connect(MapCurrencyToProps)(withTranslation()(BookingBar))
